export const THEMES = {
    BASE: 'base',
    BLUE: 'blue',
}
